module.exports = __webpack_public_path__ + "media/images/project/open-in-new-f841f2587f5e888be712f1e6c25e55c8.svg";